import React from 'react';
import styles from './ItemDetailArmmorN.scss';
import classNames from 'classnames/bind';

import {NumericFormat} from 'react-number-format';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { 
//   faX
// } from '@fortawesome/free-solid-svg-icons';

import Adsense300250 from 'components/adsense/Adsense300250';
// import Adsense23055 from 'components/adsense/Adsense23055';

const cx = classNames.bind(styles);

const bodyUpList = [
  {name: '기본', value: 0},
  {name: '초보', value: 1},
  {name: '숙련', value: 2},
  {name: '전문', value: 3},
  {name: '장인', value: 4},
  {name: '명인', value: 5},
  {name: 'O.T', value: 6}
];

const plusUpList = [
  {name: '0플', value: 0},
  {name: '1플', value: 1},
  {name: '2플', value: 2},
  {name: '3플', value: 3},
  {name: '4플', value: 4},
  {name: '5플', value: 5},
  {name: '6플', value: 6},
  {name: '7플', value: 7},
  {name: '8플', value: 8},
  {name: '9플', value: 9},
  {name: '10플', value: 10},
  {name: '11플', value: 11},
  {name: '12플', value: 12},
  {name: '13플', value: 13},
  {name: '14플', value: 14},
  {name: '15플', value: 15}
];

const prefixUpList = [ //dmg1:일반, dmg2:원피스, dmg3:변이
  {name: '없음', ctt: '', clyn: '', humanYn: ''},
  {name: '전설의', ctt: '공격/방어/회피', clyn: 'N', humanYn: 'Y',
  option: {
    cl: {dmg: {
      '감염체전용의상': '24', '가발': '2', '모자': '3', 
      '코트': '9', '상의': '4', '하의': '6', '드레스': '10'
    },dfs: {
      '감염체전용의상': 1.83, '가발': 1.8, '모자': 1.8, 
      '코트': 1.8, '상의': 1.8, '하의': 1.8, '드레스': 1.8
    }},
    noncl: {dmg: {
      '감염체전용의상': '20', '가발': '2', '모자': '2', 
      '코트': '8', '상의': '3', '하의': '5', '드레스': '8'
    },dfs: {
      '감염체전용의상': 1.83, '가발': 1.8, '모자': 1.8, 
      '코트': 1.8, '상의': 1.8, '하의': 1.8, '드레스': 1.8
    }}
  }},
  {name: '고대의', ctt: '공격/방어', clyn: 'N', humanYn: 'Y',
  option: {
    cl: {dmg: {
      '감염체전용의상': '24', '가발': '2', '모자': '3', 
      '코트': '9', '상의': '4', '하의': '6', '드레스': '10'
    },dfs: {
      '감염체전용의상': 1.83, '가발': 1.8, '모자': 1.8, 
      '코트': 1.8, '상의': 1.8, '하의': 1.8, '드레스': 1.8
    }},
    noncl: {dmg: {
      '감염체전용의상': '20', '가발': '2', '모자': '2', 
      '코트': '8', '상의': '3', '하의': '5', '드레스': '8'
    },dfs: {
      '감염체전용의상': 1.83, '가발': 1.8, '모자': 1.8, 
      '코트': 1.8, '상의': 1.8, '하의': 1.8, '드레스': 1.8
    }}
  }},
  {name: '의지의', ctt: '방어', clyn: 'N', humanYn: 'Y',
  option: {
    cl: {dfs : {
      '감염체전용의상': 2.8, '가발': 2.8, '모자': 2.8, 
      '코트': 2.8, '상의': 2.8, '하의': 2.8, '드레스': 2.8
    }},
    noncl: {dfs : {
      '감염체전용의상': 2.3, '가발': 2.3, '모자': 2.3, 
      '코트': 2.3, '상의': 2.3, '하의': 2.3, '드레스': 2.3
    }}
  }},
  {name: '민첩의', ctt: '회피', clyn: 'N', humanYn: 'Y'},
  {name: '생명의', ctt: '체력', clyn: 'N', humanYn: 'Y',
  option: {
    cl: {con: {
      '감염체전용의상': '1200', '가발': '120', '모자': '180', 
      '코트': '360', '상의': '240', '하의': '300', '드레스': '540'
    }},
    noncl: {con: {
      '감염체전용의상': '1000', '가발': '100', '모자': '150', 
      '코트': '300', '상의': '200', '하의': '250', '드레스': '450'
    }}
  }},
  {name: '근성의', ctt: '지구력', clyn: 'N', humanYn: 'Y'},
  {name: '신속의', ctt: '이동속도', clyn: 'N', humanYn: 'Y'},

  {name: '영생의', ctt: '방어/체력', clyn: 'Y', humanYn: 'Y',
  option: {
    cl: {con: {
      '감염체전용의상': '1200', '가발': '120', '모자': '180', 
      '코트': '360', '상의': '240', '하의': '300', '드레스': '540'
    }, dfs: {
      '감염체전용의상': 2.3, '가발': 2.3, '모자': 2.3, 
      '코트': 2.3, '상의': 2.3, '하의': 2.3, '드레스': 2.3
    }}
  }},
  {name: '용기의', ctt: '방어/치명', clyn: 'Y', humanYn: 'Y',
  option: {
    cl: {cri: {
      '감염체전용의상': '42', '가발': '4', '모자': '4', 
      '코트': '17', '상의': '6', '하의': '11', '드레스': '17'
    }, dfs: {
      '감염체전용의상': 1.83, '가발': 1.8, '모자': 1.8, 
      '코트': 1.8, '상의': 1.8, '하의': 1.8, '드레스': 1.8
    }}
  }},
  {name: '초월의', ctt: '공격/치명', clyn: 'Y', humanYn: 'Y',
  option: {
    cl: {dmg: {
      '감염체전용의상': '24', '가발': '2', '모자': '3', 
      '코트': '9', '상의': '4', '하의': '6', '드레스': '10'
    }, cri: {
      '감염체전용의상': '42', '가발': '4', '모자': '4', 
      '코트': '17', '상의': '6', '하의': '11', '드레스': '17'
    }}
  }},

  {name: '전설의', ctt: '공격/방어/회피', clyn: 'N', humanYn: 'N',
  option: {
    cl: {dmg: {
      '감염체전용의상': '24', '가발': '2', '모자': '3', 
      '코트': '9', '상의': '4', '하의': '6', '드레스': '10'
    }, dfs: {
      '감염체전용의상': 1.83, '가발': 1.8, '모자': 1.8, 
      '코트': 1.8, '상의': 1.8, '하의': 1.8, '드레스': 1.8
    }},
    noncl: {dmg: {
      '감염체전용의상': '20', '가발': '2', '모자': '2', 
      '코트': '8', '상의': '3', '하의': '5', '드레스': '8'
    }, dfs: {
      '감염체전용의상': 1.83, '가발': 1.8, '모자': 1.8, 
      '코트': 1.8, '상의': 1.8, '하의': 1.8, '드레스': 1.8
    }}
  }},
  {name: '고대의', ctt: '공격/회피', clyn: 'N', humanYn: 'N',
  option: {
    cl: {dmg: {
      '감염체전용의상': '24', '가발': '2', '모자': '3', 
      '코트': '9', '상의': '4', '하의': '6', '드레스': '10'
    }},
    noncl: {dmg: {
      '감염체전용의상': '20', '가발': '2', '모자': '2', 
      '코트': '8', '상의': '3', '하의': '5', '드레스': '8'
    }}
  }},
  {name: '용기의', ctt: '치명/회피', clyn: 'N', humanYn: 'N',
  option: {
    cl: {cri: {
      '감염체전용의상': '42', '가발': '4', '모자': '4', 
      '코트': '17', '상의': '6', '하의': '11', '드레스': '17'
    }},
    noncl: {cri: {
      '감염체전용의상': '35', '가발': '3', '모자': '3', 
      '코트': '15', '상의': '5', '하의': '9', '드레스': '14'
    }}
  }},
  {name: '광채의', ctt: '방어/회피/이동속도', clyn: 'N', humanYn: 'N',
  option: {
    cl: {dfs: {
      '감염체전용의상': 2.8, '가발': 2.8, '모자': 2.8, 
      '코트': 2.8, '상의': 2.8, '하의': 2.8, '드레스': 2.8
    }},
    noncl: {dfs: {
      '감염체전용의상': 2.3, '가발': 2.3, '모자': 2.3, 
      '코트': 2.3, '상의': 2.3, '하의': 2.3, '드레스': 2.3
    }}
  }},
  {name: '화려한', ctt: '방어/회피', clyn: 'N', humanYn: 'N',
  option: {
    cl: {dfs: {
      '감염체전용의상': 3.0, '가발': 2.8, '모자': 2.8, 
      '코트': 2.8, '상의': 2.8, '하의': 2.8, '드레스': 2.8
    }},
    noncl: {dfs: {
      '감염체전용의상': 2.3, '가발': 2.3, '모자': 2.3, 
      '코트': 2.3, '상의': 2.3, '하의': 2.3, '드레스': 2.3
    }}
  }},
  {name: '신비한', ctt: '방어/이동속도', clyn: 'N', humanYn: 'N',
  option: {
    cl: {dfs: {
      '감염체전용의상': 2.8, '가발': 2.8, '모자': 2.8, 
      '코트': 2.8, '상의': 2.8, '하의': 2.8, '드레스': 2.8
    }},
    noncl: {dfs: {
      '감염체전용의상': 2.3, '가발': 2.3, '모자': 2.3, 
      '코트': 2.3, '상의': 2.3, '하의': 2.3, '드레스': 2.3
    }}
  }},
  {name: '빛나는', ctt: '회피/이동속도', clyn: 'N', humanYn: 'N'},

  {name: '영생의', ctt: '방어/체력', clyn: 'Y', humanYn: 'N',
  option: {
    cl: {con: {
      '감염체전용의상': '1200', '가발': '120', '모자': '180', 
      '코트': '360', '상의': '240', '하의': '300', '드레스': '540'
    }, dfs: {
      '감염체전용의상': 2.8, '가발': 2.8, '모자': 2.8, 
      '코트': 2.8, '상의': 2.8, '하의': 2.8, '드레스': 2.8
    }}
  }},
  {name: '영웅의', ctt: '방어/공격', clyn: 'Y', humanYn: 'N',
  option: {
    cl: {dmg: {
      '감염체전용의상': '28'
    }, dfs: {
      '감염체전용의상': 1.83
    }}
  }},
  {name: '초월의', ctt: '공격/치명', clyn: 'Y', humanYn: 'N',
  option: {
    cl: {dmg: {
      '감염체전용의상': '24'
    }, cri: {
      '감염체전용의상': '42'
    }}
  }},
  //CL방어구 조합비용 일반100EP, 드레스200EP, 변이체500EP 2017-04-13 Update
];

const ItemDetailArmmor = ({currSelArmmor, popupClose, setBodyup, setPowerup, setPrefixUp, ctrlArmmorUp, plusUpGrid}) => {
  const {currItem, currItemDefensedBy, currItemOption} = currSelArmmor;
  const {optionView, bodyUp, powerUp, prefixUp} = currItemOption;
  const {ITEM_NM, IMG_SRC, DFS, ITEM_DTL_DV, TIER/*, WEIGHT*/, DOT, CLYN, STYPE2} = currItem;

  //plusUPGrid 1tier(0:일반,1:원피스,2:변이) 2tier(0:장인,1:명인,2:OT)
  //3tier (0:3급~8:11급) 4tier (0:1플~14:15플)
  //CL은 최종값의 (plusup*1.1).toFixed(2)
  const plusGrid1Deps = ITEM_DTL_DV !== undefined ? ((ITEM_DTL_DV.indexOf('감염') > -1) ? 2 : 
    ((ITEM_NM.indexOf('드레스') > -1 || ITEM_NM.indexOf('원피스')) > -1) ? 1 : 0) : -1;
  const plusGrid2Deps = Number(bodyUp) - 4;
  const plusGrid3Deps = Number(TIER) - 3;
  const plusGrid4Deps = Number(powerUp) - 1;
  
  let plusUpDmg = 
    (plusGrid1Deps > -1 && plusGrid2Deps > -1 && 
      plusGrid3Deps > -1 && plusGrid4Deps > -1 && plusUpGrid.length > 0) ? 
      plusUpGrid[plusGrid1Deps][plusGrid2Deps][plusGrid3Deps][plusGrid4Deps] : 0
  ;

  plusUpDmg = CLYN === 'Y' ? (plusUpDmg*1.1).toFixed(2) : plusUpDmg;

  let plusUpDmg1 = //방어력 곱계산에 사용. 
    (plusGrid1Deps > -1 && plusGrid2Deps > -1 && 
      plusGrid3Deps > -1 && plusGrid4Deps > -1 && plusUpGrid.length > 0) ? 
      plusUpGrid[0][plusGrid2Deps][plusGrid3Deps][plusGrid4Deps] : 0
  ;

  plusUpDmg1 = CLYN === 'Y' ? (plusUpDmg1*1.1).toFixed(2) : plusUpDmg1;


  const bodyBtns = bodyUpList.map((ele, cnt) => {
    const {name} = ele;
  
    return (
      <>
        <input type='radio' id={`textureUp${cnt}`} name='textureUp'
        alt={name} value={name} key={cnt} />
        <label className={cx(`up${cnt}`)} htmlFor={`textureUp${cnt}`}
        onClick={() => setBodyup(cnt)}>{name}</label>
      </>
    )
  });

  const plusUpBtns = plusUpList.map((ele, cnt) => {
    const {name} = ele;
  
    return (
      <>
        <input type='radio' id={`plusUp${cnt}`} name='plusUp' alt={name} value={name} key={cnt} />
        <label className={cx(`up${cnt}`)} htmlFor={`textureUp${cnt}`}
        onClick={() => setPowerup(cnt)}>{name}</label>
      </>
    )
  });

  const prefixUpFilter = prefixUpList.filter(obj => {
    const {clyn, humanYn, name} = obj;

    return (
      name === '없음' || (
        CLYN === 'Y' ? (
          ITEM_DTL_DV === '감염체전용의상' ? 
            humanYn === 'N' : humanYn === 'Y'
        ) : (
          ITEM_DTL_DV === '감염체전용의상' ? 
            clyn === 'N' && humanYn === 'N' : clyn === 'N' && humanYn === 'Y'
        )
      )
    )
  });
  
  const prefixUpBtns = prefixUpFilter.map((ele, cnt) => {
    const {name} = ele;

    return (
      <>
        <input type='radio' id={`prefixUp${cnt}`} name='prefixUp' alt={name} value={name} key={cnt} />
        <label className={cx(`up${cnt}`)} htmlFor={`textureUp${cnt}`}
        onClick={() => setPrefixUp(name==='없음'?-1:cnt)}>{name}</label>
      </>
    )
  });
  
  const prefixDtlKey = ITEM_DTL_DV === undefined ? '' :
    ITEM_DTL_DV.indexOf('가발') > -1 ? '가발' :
    ITEM_DTL_DV.indexOf('모자') > -1 ? '모자' :
    ITEM_DTL_DV.indexOf('자켓') > -1 || ITEM_DTL_DV.indexOf('코트') > -1 ? '코트' :
    ITEM_DTL_DV.indexOf('상의') > -1 ? '상의' :
    ITEM_DTL_DV.indexOf('하의') > -1 ? '하의' :
    ITEM_DTL_DV.indexOf('드레스') > -1 || ITEM_DTL_DV.indexOf('원피스') > -1 ? '드레스' :
    ITEM_DTL_DV
  ;

  const prefixDtlClKey = CLYN === undefined ? 
    'noncl' : (CLYN === 'Y' ? 'cl' : 'noncl')
  ;

  const currPrefixOption = prefixUp > -1 ? 
  prefixUpFilter[prefixUp].option === undefined ? {} :
  prefixUpFilter[prefixUp].option[prefixDtlClKey] : {};
  
  const prefixDmg = currPrefixOption.dmg === undefined ? 
    '0' : currPrefixOption.dmg[prefixDtlKey];

  const prefixCri = currPrefixOption.cri === undefined ? 
  '0' : currPrefixOption.cri[prefixDtlKey];

  const prefixCon = currPrefixOption.con === undefined ? 
    '0' : currPrefixOption.con[prefixDtlKey];

  const prefixDfs = currPrefixOption.dfs === undefined ? 
    1 : currPrefixOption.dfs[prefixDtlKey];

  String.prototype.insertAt = function(index,str){
    return this.slice(0,index) + str + this.slice(index)
  }

  return (
    <div className={cx('item-card')}>
      <h2>
        {
          prefixUp > -1 ? ITEM_NM.insertAt((CLYN==='Y'?5:0), prefixUpFilter[prefixUp].name + ' ')
          : ITEM_NM
        }
      </h2>

      <div className={cx('item-content')}>
        <div className={cx('item-left')}>
          <div className={cx('item-img')}>
            <img src={IMG_SRC} alt={ITEM_NM} />
          </div>

          <div className={cx('item-btn-group')}>
            <button className={cx('item-btn')} onClick={ctrlArmmorUp} /*onMouseOver={ctrlArmmorUp}*/ value='재질'>재질선택</button>
            {ITEM_DTL_DV === undefined ? <></> :
              (ITEM_DTL_DV.indexOf('방패') > -1  || ITEM_DTL_DV.indexOf('신발') > -1 || ITEM_DTL_DV.indexOf('스타킹') > -1 || TIER < 6) ? <></> :
              <>
              <button className={cx('item-btn')} onClick={ctrlArmmorUp} /*onMouseOver={ctrlArmmorUp}*/ value='플업'>플업선택</button>
              <button className={cx('item-btn')} onClick={ctrlArmmorUp} /*onMouseOver={ctrlArmmorUp}*/ value='접두사'>접두사</button>
              </>
            }
            <div className={cx('combo-box')} style={
              optionView === '' ? {display:'none'} : 
              (optionView === '플업' ? {left:'82px',display:'grid'} : 
                (optionView === '접두사' ? {left:'94px',display:'grid'} : {display:'grid'})
              )
            }>
              {optionView === '재질' ? bodyBtns :
              (optionView === '플업' ? plusUpBtns : prefixUpBtns)}
            </div>
          </div>

          <div className={cx('item-info')}>
            <span className={cx('item-subtitle1')}>{prefixUp <= -1 ? '' : `향상된 ${STYPE2==='2'?'여성':'남성'}용 방어구`}</span>
            <span className={cx('item-subtitle2')}>{prefixUp <= -1 ? '' : `착용시 ${prefixUp > -1 ? prefixUpFilter[prefixUp].ctt : ''} 추가 증가`}</span>
            <span className={cx('item-line')}></span>
            <span className={cx('item-hands')}>종류: {ITEM_DTL_DV}</span>
            <span className={cx('item-grade')}>등급: {TIER}</span>
            <span className={cx('item-weight')}>무게: 0/0</span>
            <span className={cx('item-cri')}>{plusUpDmg > 0 ? `플러스: ${powerUp}` : ''}</span>
            <span className={cx('item-dmg')}>
              {plusUpDmg > 0 ? 
              <NumericFormat 
                value={String(plusUpDmg)} displayType={'text'} 
                thousandSeparator={true} 
                prefix={'공격력: '} suffix={'%'}
              /> : <span></span>}
            </span>
            <span className={cx('item-dfs')}>
              {prefixUp > -1 && (prefixUpFilter[prefixUp].name === '초월의' || ITEM_DTL_DV.indexOf('가발') > -1) ? 
              <span></span> : (ITEM_DTL_DV !== undefined && ITEM_DTL_DV.indexOf('가발') > -1 ? <span></span> :
              <NumericFormat 
                value={
                  currItemDefensedBy.length === 0 ? DFS : 
                  Math.floor(currItemDefensedBy[bodyUp][0] * (plusUpDmg1 > 0 ? (plusUpDmg1/100+1).toFixed(2) : 1)) 
                } displayType={'text'} 
                thousandSeparator={true} 
                prefix={`방어력(${bodyUpList[bodyUp].name}+${powerUp}플): `}
              />)}
            </span>
            <span className={cx('item-dfs')}>
              {prefixUp > -1 ?
                (prefixUpFilter[prefixUp].name === '초월의' || prefixUpFilter[prefixUp].ctt.indexOf('방어') === -1) ? 
                <span></span> : <>
                  <NumericFormat 
                    value={
                      currItemDefensedBy.length === 0 ? DFS : 
                      Math.floor(currItemDefensedBy[bodyUp][0] * (plusUpDmg1 > 0 ? (plusUpDmg1/100+1).toFixed(2) : 1) * ((prefixDfs-0.4) < 1 ? 1 : (prefixDfs-0.4)) )
                    } displayType={'text'} 
                    thousandSeparator={true} 
                    prefix={`${prefixUpFilter[prefixUp].name.substring(0,2)}방어력(예상): `}
                  />
                  ~
                  <NumericFormat 
                    value={
                      currItemDefensedBy.length === 0 ? DFS : 
                      Math.floor(currItemDefensedBy[bodyUp][0] * (plusUpDmg1 > 0 ? (plusUpDmg1/100+1).toFixed(2) : 1) * (prefixDfs+0.4) )
                    } displayType={'text'} 
                    thousandSeparator={true}
                  />
                </> :
                <></>
              }
            </span>
            <span className={cx('item-grade')}>회피도: {String(Math.floor(DOT*1.5))}</span>
            <span className={cx('item-line')}></span>
            <span className={cx('item-dmg')}>
              {prefixDmg === '0' ? '' : `공격력: ${prefixDmg}`}
            </span>
            <span className={cx('item-cri')}>
              {prefixCri === '0' ? '' : `치명율: ${prefixCri}`}
            </span>
            <span className={cx('item-con')}>
              {prefixCon === '0' ? <span></span> : 
              <NumericFormat 
              value={prefixCon} displayType={'text'} 
              thousandSeparator={true} 
              prefix={'체력: '}
            />}
            </span>
            <span className={cx('item-count')}>창고포함 보유갯수:1개</span>
              <span className={cx('item-line')}></span>
              <span className={cx('item-upgrade')}>
                <span className={cx(`up${bodyUpList[bodyUp].value}`)}>{bodyUpList[bodyUp].name} 재질</span>
                <span className={cx('up3')}>전문 코팅</span>
                <span className={cx('up3')}>전문 두께</span>
                <span className={cx('up3')}>전문 디자인</span>
              </span>
          </div>
        </div>

        <div class="ad-box">
          <Adsense300250 />
        </div>
      </div>
    </div>
  );
}

export default ItemDetailArmmor;